import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=3a5ebe2c&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
import style0 from "./Play.vue?vue&type=style&index=0&id=3a5ebe2c&prod&lang=css"
import style1 from "./Play.vue?vue&type=style&index=1&id=3a5ebe2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ebe2c",
  null
  
)

export default component.exports